import React from "react";
import Navbar from "../components/Navbar";

import Footer from "../components/Footer";
import ImageCarousel from "../components/Carousel";
import ProjectCard from "../components/ProjectCard";
import ProjectDesciption from "../components/ProjectDescription";

const Project1 = () => {
    const carouselImages = [
        {
          src: "./Semester_3/Modellbild.webp",
          alt: "Model",
          text: "Atmospheric View from the Village Centre."
        },
        {
          src: "./Semester_3/1.webp",
          alt: "Areal",
          text: "Surroundings of the Youth Hostel"
        },
      ];      

    const title = "Tireless Vitality";
    const subtitle = "A Youth Hostel in Tarasp";
    const description = "Tarasp, a small alpine village near Scuol, suffers from a lack of identity and a lack of communal meeting places. The village has no clear village centre and the first impression of the place of arrival is characterised by a dilapidated hotel. As part of a community project, the village is being revitalised with the aim of creating more living and working space and thus increasing the attractiveness of Tarasp.";
    const secondDescription = "The focus is on the new building, a youth hostel, which is being constructed behind the old hotel in an idyllic park. The park, equipped with fire pits, groups of trees, a playground and a pond, serves as a centre for recreation and encounters and is intended to appeal to younger people in particular by offering inexpensive accommodation and leisure facilities. The building is connected to the main road via a road. The youth hostel is deliberately located slightly out of the way so that the residents of the neighbouring houses do not feel disturbed by the noise of the building.";
    const thirdDescription = "The youth hostel extends over three floors: a basement, a ground floor and an upper floor. The structure of the building is such that the bedrooms are located on the sides of the two upper floors, while the meeting areas and reception are positioned in the centre. The basement houses the kitchen, dining room and play areas available to the community. The basement has access to a terrace that leads directly to the playground, thus creating a flowing connection between the interior and the open space, and the building is connected by a continuous corridor on all floors, which ends at a sitting window and offers a view of the surroundings. The rooms are designed for two people and have wooden panelling to create a warm, pleasant atmosphere. The veranda in the entrance area and sheltered terrace on the upper floor offer a beautiful view of the park. The façade facing the park features a striking, stacked stone column, which is also continued in the interior smoke, creating a visual connection between the outside and inside."
    const map = "./Semester_3/GraubündenKarteTarasp.webp";
    const semester = "Fallsemester 2023";
    const professosr = "3rd semester at Boltshauser";
    const tools = "created with ArchiCAD, Cinema 4D, Midjourney, Photoshop";
    const coAuthor = "";

    const cards = [
      {
        id: 1,
        content: <p>Ground floor collage shows large veranda on ground level with the c-shaped building.</p>,
        className: "h-40 bg-blue-500",
        thumbnail: "./Semester_3/2.webp",
      },
      {
        id: 2,
        content: <p>Cut section collage showcasing idea. The building is set on a base, which allows to lift the basement floor a metre.</p>,
        className: "h-40 bg-red-500",
        thumbnail: "./Semester_3/3.webp",
      },
      {
        id: 3,
        content: <p>The basement level contains the kitchen and eating room along with the large play room and a sauna.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/4.webp",
      },
      {
        id: 4,
        content: <p>The Ground floor contains the reception in the middle and the sleeping quarters on either side.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/5.webp",
      },
      {
        id: 5,
        content: <p>The first and second floors are designated to the sleeping quarters with each a communal area in the middle and a balcony in park direction. </p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/6.webp",
      },
      {
        id: 6,
        content: <p>The design of the pillars on the inside are a reflection of the ones on the façade.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/7.webp",
      },
      {
        id: 7,
        content: <p>The façade shows a rhythm through the window placement that is broken up by the middle body of the building.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/8.webp",
      },
      {
        id: 8,
        content: <p>The side of the hostel has large seat windows in the middle that allow interactions of the visitors.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/9.webp",
      },
      {
        id: 9,
        content: <p>The back side of the building is made op of another veranda that connects to the playground.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/10.webp",
      },
      {
        id: 10,
        content: <p>Detailed façade construction</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/11.webp",
      },
      {
        id: 11,
        content: <p>The walls of the bedroom are lined with wood and follow the typical Engadin style.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/12.webp",
      },
      {
        id: 12,
        content: <p>View from the reception table into the park.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_3/13.webp",
      },
    ];
    
  return (
    <>
    <div className="pb-25 flex items-center justify-center bg-[#e7e5e4]">
        <Navbar />
    </div>
    
      <ImageCarousel images={carouselImages} title={title} />
      <ProjectDesciption subtitle={subtitle} description={description} secondDescription={secondDescription} thirdDescription={thirdDescription} map={map} semester={semester} professor={professosr} tools={tools} coAuthor={coAuthor}/>
      <ProjectCard cards={cards}/>
      <Footer />
    </>
  );
};

export default Project1;

